/**
 * Middleware to set a locale cookie based on the route's locale parameter.
 *
 * This middleware sets an i18n redirect cookie with the current locale,
 * which helps in maintaining language/locale persistence across page navigations.
 *
 * @param {Object} to - The route being navigated to
 * @param {Object} to.params - Route parameters
 * @param {string} [to.params.locale] - The locale extracted from the route
 *
 * @returns {void}
 *
 * @example
 * When navigating to a route with locale 'en'
 *  Sets a cookie 'i18n_redirected' with value 'en'
 *  On localhost, cookie domain is 'localhost'
 *  On production, cookie domain is '.armani.com'
 */
export default defineNuxtRouteMiddleware(to => {
  const locale = to?.params?.locale as string
  if (locale) {
    const i18nRedCookie = useCookie('i18n_redirected', {
      domain: import.meta.dev ? 'localhost' : '.armani.com',
    })
    i18nRedCookie.value = locale
  }
})
